import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  width: 100%;
  position: relative;
  background: ${(props) => props.theme.colors.background};
  border-right: 1px solid ${(props) => props.theme.colors.primary};
`
